import React, { useState } from "react";
import ReactDOM from "react-dom";
import "./GiftUsModal.css";

const GiftUsModal = ({ onClose }) => {
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const handleDonate = () => {
    setShowToast(true);

    setTimeout(() => {
      const hostedButtonId = "EKUTRRTWPAAZY";
      const baseUrl = `https://www.paypal.com/donate?hosted_button_id=${hostedButtonId}`;

      // Custom tracking (optional — PayPal may ignore this param in donation)
      const note = `${name ? `From: ${name}` : ""}${message ? ` | ${message}` : ""}`;
      const url = note ? `${baseUrl}&custom=${encodeURIComponent(note)}` : baseUrl;

      window.open(url, "_blank");

      setTimeout(() => {
        setShowToast(false);
        onClose();
      }, 3000);
    }, 2500);
  };

  const modalContent = (
    <div className="gift-modal-overlay">
      <div className="gift-modal-content">
        <div className="gift-modal-header">
          <h2>🎁 Support Scoldy Social</h2>
          <button className="modal-close" onClick={onClose}>
            &times;
          </button>
        </div>

        <div className="gift-modal-body">
          <label htmlFor="gift-name">Your Name <span>(optional)</span></label>
          <input
            id="gift-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Jane Doe"
          />

          <label htmlFor="gift-message">Message <span>(optional)</span></label>
          <textarea
            id="gift-message"
            rows="3"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Thanks for building a better network!"
          />
        </div>

        <div className="gift-modal-footer">
          <button className="donate-button" onClick={handleDonate}>
            Donate via PayPal
          </button>
        </div>
      </div>

      {showToast && (
        <div className="toast-message">
          ✅ Donation window opened — thank you!
        </div>
      )}
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default GiftUsModal;
